<template>
  <v-container class="survey-settings" fluid>
    <page-title title="Settings"></page-title>
    <Tabs :settings="tabSettings"></Tabs>
    <v-layout align-center class="setting">
      <span>Show the first survey after</span>
      <input
        class="lgrm-box-input"
        type="number"
        @input="save()"
        v-model="formData.throttle"
        v-validate="'required|min_value:1|max_value:365'"
        data-vv-as="throttle"
        name="throttle"
        :class="{ error: errors.collect('throttle').length > 0 }"
      />
      <span>days</span>
    </v-layout>
    <v-layout align-center class="setting">
      <span>If user responds, show the next survey after</span>
      <input
        class="lgrm-box-input"
        type="number"
        @input="save()"
        v-model="formData.responseDelay"
        v-validate="'required|min_value:1|max_value:365'"
        data-vv-as="responseDelay"
        name="responseDelay"
        :class="{ error: errors.collect('responseDelay').length > 0 }"
      />
      <span>days</span>
    </v-layout>
    <v-layout align-center class="setting">
      <span>If user declines, show the survey again in</span>
      <input
        class="lgrm-box-input"
        type="number"
        @input="save()"
        v-model="formData.rejectDelay"
        v-validate="'required|min_value:1|max_value:365'"
        data-vv-as="rejectDelay"
        name="rejectDelay"
        :class="{ error: errors.collect('rejectDelay').length > 0 }"
      />
      <span>days</span>
    </v-layout>
  </v-container>
</template>

<script>
import debounce from 'lodash/debounce'
import formMixins from '@/mixins/forms'
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
export default {
  name: 'SurveySettings',
  mixins: [formMixins],
  components: {Tabs},
  data: function() {
    return {
      formData: {
        throttle: this.$store.getters['user/currentCampaign'].options
          .first_survey_delay,
        responseDelay: this.$store.getters['user/currentCampaign'].options
          .responded_delay,
        rejectDelay: this.$store.getters['user/currentCampaign'].options
          .rejected_delay
      }
    }
  },
  computed: {
    tabSettings: function() {
      return {
        preselected: null,
        tabs: [
          {
            id: routes.SURVEY_SETTINGS,
            label: 'Settings'
          },
          {
            id: routes.SURVEY_INTEGRATIONS,
            label: 'Integrations'
          },
          {
            id: routes.SURVEY_PUBLISH,
            label: 'Publish'
          }
        ]
      }
    }
  },
  methods: {
    save: debounce(function() {
      if (!this.isFormValid) {
        return
      }
      const data = {}
      data.first_survey_delay = +this.formData.throttle
      data.rejected_delay = +this.formData.rejectDelay
      data.responded_delay = +this.formData.responseDelay
      data.campaignId = this.$router.currentRoute.params.campaignId
      this.$store
        .dispatch('campaign/updateCampaignSettings', data)
        .then(function(campaign) {
          console.log(campaign)
        })
    }, 500)
  }
}
</script>

<style lang="stylus">
.survey-settings {
    .setting {
        margin-bottom 37px
        font-size 16px
        .lgrm-box-input {
        width 60px
        margin 0 5px
        height 40px
    }
    }

}
</style>
